export const getKeys = <TObj extends Record<string, any>>(obj: TObj) =>
  Object.keys(obj) as (keyof TObj)[];

export const hasOwnProp = <TObj extends Record<string, any>>(
  obj: TObj,
  key: string | number | symbol,
): key is keyof TObj => Object.prototype.hasOwnProperty.call(obj, key);
